import $http from '../assets/js/http'

export function getList (params, enableLoading = true) {
  $http.custom(params, {moduleId: '701', enableLoading: enableLoading})
  return $http.post('/idea/query/list', params)
}

export function getEntity (params) {
  $http.custom(params, {moduleId: '702'})
  return $http.post('/idea/query/info', params)
}

export function add (params) {
  $http.custom(params, {moduleId: '703'})
  return $http.post('/idea/add/info', params)
}

export function update (params) {
  $http.custom(params, {moduleId: '705'})
  return $http.post('/idea/update/info', params)
}

export function updateDeliveryStatus (params) {
  $http.custom(params, {moduleId: '706'})
  return $http.post('/idea/update/status', params)
}

export function getChangeList (params) {
  $http.custom(params, {moduleId: '707'})
  return $http.post('/idea/query/apply/list', params)
}

export function updateAuditStatus (params) {
  $http.custom(params, {moduleId: '707'})
  return $http.post('/idea/verify', params)
}

export function updateBanStatus (params) {
  $http.custom(params, {moduleId: '707'})
  return $http.post('/idea/disabled', params)
}

export default {
  getChangeList,
  getList,
  getEntity,
  add,
  update,
  updateDeliveryStatus,
  updateAuditStatus,
  updateBanStatus
}



// WEBPACK FOOTER //
// ./src/api/idea.js